/* eslint-disable no-undef */
import Axios from 'axios';

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;
export const MODE = process.env.REACT_APP_MODE;

const axios = Axios.create({
  baseURL: BASE_URL,
});

export default axios;
